import Graphs from './components/graphs';
import initSwipers from './components/swipers';
import initToggleButtons from './components/toggle';
import Gallery from './components/gallery';
import Swiper from 'swiper';
import { Navigation, Pagination, A11y } from 'swiper/modules';
import 'swiper/css/bundle';


Graphs.init();
initSwipers();

(function(){
    let gallerySwiper = null;

    Gallery.init(document.querySelector('.exhibition-gallery'), {
        templateSelector: '#gallery-template',
        imageSelector: 'a',
        onInit: (galleryElement) => {
            galleryElement.querySelector('.gallery-title').innerText = document.querySelector('h1').innerText;
            
            galleryElement.querySelector(".gallery-modal-content").addEventListener('click', (event) => {
                //event.preventDefault();
                //event.stopPropagation();
            })
            gallerySwiper = new Swiper(galleryElement.querySelector(".gallery-slider"), {
                slidesPerView: 1,
                spaceBetween: 0,
                modules: [Navigation, Pagination, A11y],
                navigation: {
                nextEl: ".single-slider-next",
                prevEl: ".single-slider-prev",
                },
                pagination: {
                    el: ".gallery-modal-slider-pagination",
                    type: "fraction",
                },
                on: {
                    slidesUpdated: (swiper) => {
                        let index_currentSlide = swiper.realIndex;
                        let currentSlide = swiper.slides[index_currentSlide];
                        if (currentSlide) {
                            document.querySelector('.gallery-modal-download').setAttribute('href', currentSlide.querySelector('img').getAttribute('src'));
                        }
                    },

                    slideChange: (swiper) => {
                        let index_currentSlide = swiper.realIndex;
                        let currentSlide = swiper.slides[index_currentSlide];
                        if (currentSlide) {
                            document.querySelector('.gallery-modal-download').setAttribute('href', currentSlide.querySelector('img').getAttribute('src'));
                        }
                    }
                }
            });

        },

        onImageInit: function(imageElement, image, index) {
            const imageCaption = image.getAttribute('data-caption');
            const captionElement =  imageElement.querySelector('figcaption');
            if (imageCaption) {
                captionElement.innerText = image.getAttribute('data-caption');
            } else {
                captionElement.classList.add('hidden');
                captionElement.classList.add('lg:block');
            }
        },

        onBeforeOpenModal: (image, index) => {
            gallerySwiper.slideTo(index, 0);
        }
    });
})();

/**
 * Content gallery
 */
(function(){
    const galleries = document.querySelectorAll('.gallery-slider');
    if (!galleries) return;

    galleries.forEach(gallery => {
        let gallerySwiper = null;

        const documentGallery = gallery;
        const isDefault = documentGallery.classList.contains('gallery-slider-default');

        Gallery.init(documentGallery, {
            templateSelector: '#gallery-template',
            imageSelector: '.swiper-slide a',
            onInit: (galleryElement) => {
                const galleryTitle = documentGallery.getAttribute('title');
                if (galleryTitle) {
                    galleryElement.querySelector('.gallery-title').innerText = galleryTitle;
                } else {
                    galleryElement.querySelector('.gallery-title').remove();
                }
                
                galleryElement.querySelector(".gallery-modal-content").addEventListener('click', (event) => {
                    //event.preventDefault();
                    //event.stopPropagation();
                })

                if (!isDefault) {
                    galleryElement.querySelector(".gallery-modal-download").remove();
                }

                gallerySwiper = new Swiper(galleryElement.querySelector(".gallery-slider"), {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    modules: [Navigation, Pagination, A11y],
                    navigation: {
                    nextEl: ".single-slider-next",
                    prevEl: ".single-slider-prev",
                    },
                    pagination: {
                        el: ".gallery-modal-slider-pagination",
                        type: "fraction",
                    },
                    on: {
                        slidesUpdated: (swiper) => {
                            if (!isDefault) return;
                            let index_currentSlide = swiper.realIndex;
                            let currentSlide = swiper.slides[index_currentSlide];
                            if (currentSlide) {
                                document.querySelector('.gallery-modal-download').setAttribute('href', currentSlide.querySelector('img').getAttribute('src'));
                            }
                        },

                        slideChange: (swiper) => {
                            if (!isDefault) return;
                            let index_currentSlide = swiper.realIndex;
                            let currentSlide = swiper.slides[index_currentSlide];
                            if (currentSlide) {
                                document.querySelector('.gallery-modal-download').setAttribute('href', currentSlide.querySelector('img').getAttribute('src'));
                            }
                        }
                    }
                });

            },

            onImageInit: function(imageElement, image, index) {
                let imageCaption = '';
                if (!isDefault) {
                    imageCaption = image.getAttribute('data-caption'); 
                } else {
                    const imageCaptionElement = image.parentElement.querySelector('.wp-element-caption');
                    imageCaption = imageCaptionElement ? imageCaptionElement.innerHTML : '';
                }

                const captionElement =  imageElement.querySelector('figcaption');
                if (imageCaption) {
                    captionElement.innerText = imageCaption;
                } else {
                    captionElement.classList.add('hidden');
                    captionElement.classList.add('lg:block');
                }
            },

            onBeforeOpenModal: (image, index) => {
                gallerySwiper.slideTo(index, 0);
            }
        });

    });
})();

/**
 * Filters toggle
 */
(function(){
    let initalized = false;
    document.addEventListener('facetwp-loaded', function() {
        if (!initalized) {
            initalized = true;
            return;
        }
        initToggleButtons();
    });
})();
